import { useEffect, useState } from "react";
import { isTextTarget } from "./textTarget";

/**
 * Space-as-transient-hand: while held, left-drag pans regardless of the armed tool/brush. Tracked
 * on this surface (not the parent) because it only affects this surface's drag gating.
 */
export function useSpaceHeld(): boolean {
  const [spaceHeld, setSpaceHeld] = useState(false);

  // Window-level space tracking. Ignore space inside a text field (the grid inputs) so typing a space
  // doesn't arm the hand, and only swallow the page-scroll default when we actually arm it.
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.code !== "Space" || e.repeat || isTextTarget(e.target)) return;
      e.preventDefault();
      setSpaceHeld(true);
    };
    const onKeyUp = (e: KeyboardEvent) => {
      if (e.code === "Space") setSpaceHeld(false);
    };
    // A focus loss (alt-tab, devtools) would otherwise strand the hand armed.
    const onBlur = () => setSpaceHeld(false);
    window.addEventListener("keydown", onKeyDown);
    window.addEventListener("keyup", onKeyUp);
    window.addEventListener("blur", onBlur);
    return () => {
      window.removeEventListener("keydown", onKeyDown);
      window.removeEventListener("keyup", onKeyUp);
      window.removeEventListener("blur", onBlur);
    };
  }, []);

  return spaceHeld;
}
